// src/components/landing/LandingShell.jsx
import React, { useEffect, useRef } from "react";

import "@fontsource-variable/newsreader/opsz.css";
import "@fontsource-variable/newsreader/opsz-italic.css";
import "@fontsource-variable/instrument-sans";
import "../../sass/landing/base.scss";

/*
 * Envolve a landing, aplica os tokens visuais e revela uma única vez os
 * elementos marcados com data-reveal quando entram na tela.
 * Sem JavaScript ou com movimento reduzido, tudo aparece direto.
 */
const LandingShell = ({ children }) => {
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return undefined;

    const reduce = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (reduce || !("IntersectionObserver" in window)) {
      return undefined;
    }

    root.classList.add("lp--motion");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.12 }
    );

    root
      .querySelectorAll("[data-reveal]")
      .forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // Chegando de outra página com âncora (ex.: /#planos).
    const id = window.location.hash.replace("#", "");
    if (!id) return;
    const section = document.getElementById(id);
    if (section) {
      window.requestAnimationFrame(() =>
        section.scrollIntoView({ block: "start" })
      );
    }
  }, []);

  return (
    <div className="lp" ref={rootRef}>
      <a className="lp-skip" href="#conteudo">
        Pular para o conteúdo
      </a>
      {children}
    </div>
  );
};

export default LandingShell;
